import request from "@/utils/interceptor.js";

// 文章列表
export function getPatientEducation(params) {
  return request({
    url: "/api/pas/patient-education",
    method: "get",
    params
  });
}
// 新增文章
export function postPatientEducation(data) {
  return request({
    url: "/api/pas/patient-education",
    method: "post",
    data,
  });
}
//更新文章
export function putPatientEducation(data) {
  return request({
    url: `/api/pas/patient-education/${data.id}`,
    method: "put",
    data,
  });
}
//删除文章
export function deletePatientEducation(id) {
  return request({
    url: `/api/pas/patient-education/${id}`,
    method: "delete",
  });
}